import { FC } from 'react';
import { cn } from '@shadcn/ui/lib/utils';
import { GetContactsWeightedScoresQuery } from '@zaplify/graphql';
import { QuickAddNoteButton } from './quick-add-note-button';
import { QuickSnoozeDropdown } from './quick-snooze-dropdown';
import { QuickNotInterestedButton } from './quick-not-interested-button';
import { QuickClassificationButton } from './quick-classification-button';

interface QuickActionsBarProps {
    contact: GetContactsWeightedScoresQuery['contacts_weighted_scores'][number];
    openClassificationDialogForContact: (contactId: string) => void;
    onAddNote?: (e: React.MouseEvent) => void;
    onSnooze?: (e: React.MouseEvent) => void;
    onNotInterested?: (e: React.MouseEvent) => void;
    onClassification?: (e: React.MouseEvent) => void;
    onDropdownStateChange?: (isOpen: boolean) => void;
    className?: string;
    variant?: 'default' | 'ghost' | 'outline';
    size?: 'sm' | 'icon-sm' | 'icon';
    showLabels?: boolean;
    showStopSuggestingActions?: boolean;
}

export const QuickActionsBar: FC<QuickActionsBarProps> = ({
    contact,
    openClassificationDialogForContact,
    onAddNote,
    onSnooze,
    onNotInterested,
    onClassification,
    onDropdownStateChange,
    className,
    variant = 'ghost',
    size = 'icon-sm',
    showLabels = false,
    showStopSuggestingActions = false,
}) => {
    return (
        <div className={cn('flex gap-1', className)}>
            <QuickClassificationButton
                contactId={contact.id}
                openClassificationDialogForContact={openClassificationDialogForContact}
                onClassification={onClassification}
                variant={variant}
                size={size}
                showLabel={showLabels}
                className="hover:bg-gray-100 hover:text-gray-900"
            />

            <QuickAddNoteButton
                contactId={contact.id}
                onAddNote={onAddNote}
                onDropdownStateChange={onDropdownStateChange}
                variant={variant}
                size={size}
                showLabel={showLabels}
                className="hover:bg-gray-100 hover:text-gray-900"
            />
            <QuickSnoozeDropdown
                contactFirstName={contact.firstName}
                contactId={contact.id}
                contact={contact}
                onSnooze={onSnooze}
                onDropdownStateChange={onDropdownStateChange}
                variant={variant}
                size={size}
                showLabel={showLabels}
                showStopSuggestingActions={showStopSuggestingActions}
                className="hover:bg-gray-100 hover:text-gray-900"
            />
            <QuickNotInterestedButton
                contact={contact}
                onNotInterested={onNotInterested}
                variant={variant}
                size={size}
                showLabel={showLabels}
                className="hover:bg-gray-100 hover:text-gray-900"
            />
        </div>
    );
};
